import axios from 'axios'

export default {
	logout: () => {
		axios
			.post('/api/auth/logout')
			.then(() => {
				dispatch('clearLocalStorage', null, { root: true })
			})
			.catch(({ response }) => console.log(response))
	},
}
